<div class="modal-header">
    <h4 class="modal-title">Générer de nouveaux codes</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="examForm" *ngIf="!isDataLoading">
        <div class="form-group row">
            <label for="countInput" class="col-sm-4 col-form-label text-right">Nombre de codes</label>
            <div class="col-sm-8">
                <input type="text" class="form-control" id="countInput" formControlName='count'>
                <small *ngIf="selectedInvoiceRequest" class="text-muted">
                    Cette facture répond à une demande de {{selectedInvoiceRequest.quantity}} ticket{{selectedInvoiceRequest.quantity > 1 ? 's' : ''}}.
                </small>
            </div>
        </div>
        <div class="form-group row">
            <label for="invoiceSelect" class="col-sm-4 col-form-label text-right">Facture</label>
            <div class="col-sm-8">
                <select class="form-control" formControlName="invoice" id="invoiceSelect">
                    <option *ngFor="let invoice of invoices; let i = index" [value]='invoices[i].id'>
                        {{invoices[i].label}}
                    </option>
                </select>
            </div>
        </div>
        <div class="form-group row">
            <label for="centerSelect" class="col-sm-4 col-form-label text-right">Centre d'examen</label>
            <div class="col-sm-8">
                <select class="form-control" formControlName="examCenter" id="centerSelect">
                    <option *ngFor="let examCenter of examCenters; let i = index" [value]='examCenters[i].id'>
                        {{examCenters[i].nom}}
                    </option>
                </select>
            </div>
        </div>
        <div class="form-group row">
            <label for="certificationSelect" class="col-sm-4 col-form-label text-right">
                Certification <small class="text-muted">(facultatif)</small>
            </label>
            <div class="col-sm-8">
                <select class="form-control" formControlName="certification" id="certificationSelect">
                    <option value="">Aucune</option>
                    <option *ngFor="let certification of certifications; let i = index" [value]='certifications[i].id'>
                        {{certifications[i].title}}
                    </option>
                </select>
            </div>
        </div>
        <div class="form-group row">
            <label for="sessionSelect" class="col-sm-4 col-form-label text-right">
                Session <small class="text-muted">(facultatif)</small>
            </label>
            <div class="col-sm-8">
                <select class="form-control" formControlName="session" id="sessionSelect">
                    <option value="">Aucune</option>
                    <option *ngFor="let session of sessions; let i = index" [value]='sessions[i].id'>
                        {{sessions[i].code}}
                    </option>
                </select>
                <small *ngIf="!examForm.value.examCenter" class="text-muted">
                    Sélectionnez d'abord un centre d'examen.
                </small>
                <small *ngIf="examForm.value.examCenter && !isSessionsLoading && !sessions.length" class="text-muted">
                    Aucune session à venir pour ce centre.
                </small>
            </div>
        </div>
    </form>
    <div *ngIf="error" class="alert alert-danger">
        {{error}}
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-danger" (click)="activeModal.dismiss()">Annuler</button>
    <button type="button" class="btn btn-outline-success" [disabled]="examForm.invalid" (click)="validate()">
        <span *ngIf="submitting" class="button-loader"></span>
        Valider
    </button>
</div>
